import { Link, Typography } from '@mui/material';
import { FC } from 'react';
import { CustomFormField, SpeciesForm } from '../../../../../api/dtos/dtos';
import MuiMarkdown from 'mui-markdown';

interface ICustomRedirectMessageProps {
    field: CustomFormField,
    form: SpeciesForm
}

const CustomRedirectMessage: FC<ICustomRedirectMessageProps> = ({
    field
}) => {
    return (
        <Typography
            sx={{  
                padding: "10px",

                "li:has(&)": {
                    listStyleType: 'none',
                    margin: '0'
                }
            }}
        >
            <MuiMarkdown>{field.meta?.message ?? ""}</MuiMarkdown>
            &nbsp;
            <Link target="_blank" href={field.meta?.link ?? ""}>Click here</Link>
        </Typography>

    )
}

export default CustomRedirectMessage